/**
 * @module lib/video/live-video
 * @description Allows to remove live video feature
 */
import { qsa } from "utils/utils";

export default function enableDismissLiveVideo() {
  const videoDismissBtn = qsa(".arc-live-video__dismiss-btn");
  if(!videoDismissBtn) {
    return;
  }
  videoDismissBtn.forEach(btn => btn.addEventListener("click", removeVideoContainer));
}

/**
 * @method removeVideoContainer
 * @description Removes video from the page
 * @param {Object} event
 */
function removeVideoContainer(event) {
  const videoContainer = event.target.closest(".arc-live-video");
  videoContainer && videoContainer.parentElement.removeChild(videoContainer);
}
